import { Routes } from '@angular/router';
import { UnAuthGuard } from '@/core/configuration/un-auth.guard';
import { authGuard } from '@/core/configuration/authGuard';
import { Forbidden } from '@/core/page/forbidden/forbidden.component';
import { Notfound } from '@/core/page/not-found/notfound';
import { AppLayout } from '@/layout/components/app.layout';
import { APP_ROUTES } from './app.router.config';


export const appRoutes: Routes = [
    {
        path: 'auth/login',
        canActivate: [UnAuthGuard],
        loadComponent: () => import('./app/core/page/login/login').then((m) => m.Login)
    },

    {
        path: '',
        component: AppLayout,
        canActivate: [authGuard],
        children: [
            {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full'
            },
            {
                path: 'dashboard',
                data: { breadcrumb: 'menu.dashboard' },
                loadComponent: () => import('./app/core/page/dashboard/dashboard').then((m) => m.Dashboard)
            },
            {
                path: APP_ROUTES.ONBOARD_WORKFLOW,
                data: { breadcrumb: 'module.onboarding.label' },
                loadChildren: () => import('@/module/case-workflow/onboarding/onboarding.routers')
            },
            {
                path: APP_ROUTES.WATCHLIST_WORKFLOW,
                data: { breadcrumb: 'module.watchlist.label' },
                loadChildren: () => import('@/module/case-workflow/watchlist/watchlist.routers')
            },
            {
                path: APP_ROUTES.TRANSACTION_SCREENING_WORKFLOW,
                data: { breadcrumb: 'module.trxScreening.label' },
                loadChildren: () => import('@/module/case-workflow/txn-screening/txn-screening.routers')
            },
            {
                path: APP_ROUTES.USER,
                data: { breadcrumb: 'module.userManagement.label' },
                loadChildren: () => import('./app/module/user/user.routes')
            },
            {
                path: APP_ROUTES.ROLE,
                data: { breadcrumb: 'module.userManagement.label' },
                loadChildren: () => import('./app/module/role/role.routers')
            },
            {
                path: APP_ROUTES.APPLICATION_SETTING,
                data: { breadcrumb: 'module.setting.label' },
                loadChildren: () => import('./app/module/application-setting/application.routers')
            },
            {
                path: APP_ROUTES.APPLICATION_LICENSE,
                data: { breadcrumb: 'module.setting.label' },
                loadChildren: () => import('./app/module/application-license/application-license.routers')
            },
            {
                path: APP_ROUTES.PARAMETER_SETTING,
                data: { breadcrumb: 'module.setting.label' },
                loadChildren: () => import('./app/module/parameter-setting/parameter-setting.routers')
            },
            {
                path: APP_ROUTES.MANAGE_ROLES,
                data: { breadcrumb: 'module.userManagement.label' },
                loadChildren: () => import('./app/module/manage-role/manage-role.routers')
            },
            {
                path: APP_ROUTES.EMAIL_TEMPLATE,
                data: { breadcrumb: 'module.setting.label' },
                loadChildren: () => import('./app/module/email-template/email-template.routers')
            },
            {
                path: APP_ROUTES.REMARK_TEMPLATE,
                data: { breadcrumb: 'module.setting.label' },
                loadChildren: () => import('./app/module/remark-template/remark-template.routers')
            },
            {
                path: APP_ROUTES.MANAGE_BRANCH,
                data: { breadcrumb: 'module.userManagement.label' },
                loadChildren: () => import('./app/module/manage-branch/manage-branch.routers')
            },
            {
                path: APP_ROUTES.USER_ACTIVITIES_LOG,
                data: { breadcrumb: 'module.userManagement.label' },
                loadChildren: () => import('./app/module/user-activities-log/user-activities-log.routers')
            },
            {
                path: APP_ROUTES.SETUP_WORKFLOW,
                data: { breadcrumb: 'module.setting.workflow' },
                loadChildren: () => import('./app/module/setup-workflow/setup-workflow.routers')
            }
        ]
    },
    { path: 'notfound', component: Notfound },
    { path: '403', component: Forbidden },
    { path: '**', redirectTo: '/notfound' }
];
